export default "__VITE_ASSET__BEHaUjpP__"